(function (jQuery) {
  jQuery.gfSettingAdv = function (element, options) {
    const defaults = {
      title: '',
    };

    this.settings = {};
    const $element = jQuery(element);

    const _this = this;

    /* Editor */
    const $gfLeftSideBar = jQuery('#gfLeftSideBar');

    this.init = function () {
      this.settings = jQuery.extend({}, defaults, options);

      $element.gfSettingGroup({
        title: _this.settings.title,
      });

      $element.data('gfsettinggroup').setAdvanced(true);

      return false;
    };

    this.onShow = function () {
      $element.data('gfsettinggroup').onOpacity(false);
      $gfLeftSideBar.find('.columns').css({ 'z-index': '50' });
      $element.css({ 'z-index': '200', display: 'block' });
      $element.find('.gfSettingGroup').css({ 'z-index': '200' });
    };

    this.init();
  };

  jQuery.fn.gfSettingAdv = function (options) {
    return this.each(function () {
      if (undefined == jQuery(this).data('gfsettingadv')) {
        const plugin = new jQuery.gfSettingAdv(this, options);
        jQuery(this).data('gfsettingadv', plugin);
      }
    });
  };
})(jQuery);
